import { GetBodyAdjusterImagesQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImages/getBodyDamagedAdjusterImagesQuery.type';
import { getBodyDamagedAdjusterImagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImages/getBodyDamagedAdjusterImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyDamagedAdjusterImagesQueryOptions = (
  params: GetBodyAdjusterImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getDamagedAdjusterImages', params],
    queryFn: () => getBodyDamagedAdjusterImagesQueryFunction(params),
    enabled: !!params.enable,
    select: (data) => {
      const vehicle = data.vehicle.map((item) => ({
        id: item.id,
        url: item.image,
        label: item.title.fa_const,
        en_name: item.title.const,
      }));
      const damaged_parts = data.damaged_parts.map((item) => ({
        id: item.id,
        part_id: item.part_id,
        url: item.image,
        label: item.title.fa_const,
        en_name: item.title.const,
      }));
      return { vehicle, damaged_parts };
    },
  });
};
